import { render, staticRenderFns } from "./BuildContactsList.vue?vue&type=template&id=7554295c&scoped=true"
import script from "./BuildContactsList.vue?vue&type=script&lang=js"
export * from "./BuildContactsList.vue?vue&type=script&lang=js"
import style0 from "./BuildContactsList.vue?vue&type=style&index=0&id=7554295c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7554295c",
  null
  
)

export default component.exports